import { QuickTourProgress } from 'app/core/user/user.types';
import { SaiQuickTourStep } from 'app/ui/sai-quick-tour/sai-quick-tour.types';

/**
 * Index the tour should open on when resuming a run that was closed or refreshed away.
 *
 * The saved step **id** wins over the saved index: the visible step list is permission-filtered,
 * so an index captured in one session can point at a different step in the next one. The index is
 * only a fallback for a saved step that is no longer visible (entitlements changed, step removed).
 */
export function resolveResumeIndex(
    steps: readonly SaiQuickTourStep[],
    progress: QuickTourProgress | null,
    fallbackIndex = 0,
): number {
    if (steps.length === 0) {
        return 0;
    }

    const clamp = (value: number): number => Math.max(0, Math.min(value, steps.length - 1));

    if (!progress) {
        return clamp(fallbackIndex);
    }

    const byId = steps.findIndex((step) => {
        return step.id === progress.stepId;
    });
    if (byId >= 0) {
        return byId;
    }

    return clamp(progress.stepIndex);
}
